import {
  ACTIVO_TIPOS_NIVEL_CODE,
  CLEAR_ALL,
  GETALL_TIPOS_NIVEL_CODE,
  LOADING_GETALL_TIPOS_NIVEL_CODE,
  PARAMS_TIPOS_NIVEL_CODE,
  SET_LOGOUT,
} from '../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  activo: null,
  params: {},
};

export const tiposNivelCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_TIPOS_NIVEL_CODE:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_TIPOS_NIVEL_CODE:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_TIPOS_NIVEL_CODE:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_TIPOS_NIVEL_CODE:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
